import { useEffect } from 'react';
import { getUsers } from '../../../API/Service/userLoginService';
import { tbkProduct_getItems } from '../../../API/Service/tbkProductService';
import { calculateCGST_SGST, dynamicSum, getQuotations, getSumByKey, quotationUpdate } from '../../../API/Service/quotationService';


 
export const loadPartyOptions=async(inputValue)=>{     
  try {    
    const resData=await getUsers({p_search:inputValue,
     limit:25});
     return resData?.data?.map((party) => ({
      value: party.id,
      label: party.ownerName,
      ...party
    })); 
  } catch (error) {
    console.error("Failed to load party options:", error);
    return [];
  }finally{
    
  }
}

export const loadProductOptions=async(inputValue)=>{     
  try {    
    const resData=await tbkProduct_getItems({p_search:inputValue,
     limit:25,action:'getProducts'});
     return resData?.data?.map((item) => ({
      value: item.id,
      label: item.productname,
      ...item
    })); 
  } catch (error) {
    console.error("Failed to load product options:", error);
    return [];
  }finally{
    
  }
}

export const handleChangeCheckBox = (isChecked,setIsChecked) => {
  setIsChecked(!isChecked); // Toggle the checkbox state
};

export const handleGetFormQuotations=async({id,
  setQuotation, setLoading, showToast})=>{  
 setLoading(true);
 try {
   let data={id:id,limit:1}    
   const resData=await getQuotations(data);
   setQuotation(resData?.data?.[0] || {});   

 } catch (error) {
   showToast("Something went wrong! Please try again", 'danger');
 }finally{
   setLoading(false);
 }
}

export const useLoadQuotation = ({setQuotation, 
  setLoading, showToast,id,isReadOnly}) => {
  useEffect(() => {      
    if(isReadOnly){      
      handleGetFormQuotations({setQuotation, setLoading,
        showToast,id })             
      }       
    }, []);
    
};

export const handleItemAmountChange = (setFieldValue, index, qty, rate) => {
  const quantity = parseFloat(qty) || 0;
  const unitRate = parseFloat(rate) || 0;
  const amount = quantity * unitRate;

  setFieldValue(`details[${index}].item_amount`, amount.toFixed(2));
};

export const handleQuotationFormUpdate=async(
  {values,showToast,setSubmitLoading,navigate})=>{
  try {
    
    const subTotal=getSumByKey(values?.details, "item_amount");
    const { cgst, sgst } = calculateCGST_SGST(subTotal, 0);
    const grand_total=dynamicSum(subTotal,cgst,sgst);
    values={...values,
      sub_total:subTotal,
      gst_percent: 0,
      s_gst: cgst,
      c_gst: sgst,
      grand_total:grand_total,
      paid_amount:grand_total,
    }
    // alert(JSON.stringify(values))
    setSubmitLoading(true)
    const resData=await quotationUpdate(values) 
    if(resData?.data?.id > 0)   
    {      
      showToast(`Quotation Updated successfully`, 'success');      
      setTimeout(() => {
        navigate("/admin/quotation-list")        
      },100);
    }else{
      showToast("Something went wrong! Please try again", 'danger');  
    }
  } catch (error) {
    showToast("Something went wrong! Please try again", 'danger');
  }finally {
    setSubmitLoading(false)
  }
}